import axios from 'axios';

export const getRequestById = async ({ id }) => {
  const res = await axios.get(`/requests/${id}`);
  return res;
};

export const getMyRequests = async ({ id, params }) => {
  const res = await axios.get(`/employees/${id}/requests?${params.toString()}`);
  if (res.status !== 200) {
    throw new Error('Network response was not ok');
  }
  return res;
};

export const getAllRequests = async ({ params }) => {
  const res = await axios.get(`/requests?${params.toString()}`);
  if (res.status !== 200) {
    throw new Error('Network response was not ok');
  }
  return res;
};
